
import Error from "./Error";
import { useFieldContext } from "./Field";

const ErrorList = props => {
  const { fieldErrorId } = useFieldContext();

  if (!props.isInvalid) {
    return null;
  }

  return (
    <div id={fieldErrorId} className="form-errors">
      {props.errors.map((error, index) => (
        <Error key={index} error={error} />
      ))}
    </div>
  );
};

export default ErrorList;
